export const multiplyValues = (obj: any, value: number): any => {
  console.log('multiplyValues: object', obj)
  console.log('multiplyValues: value', value)
  const newObj = { ...obj }
  for (const key in newObj) {
    if (typeof newObj[key] === 'number') {
      newObj[key] *= value
    }
  }
  console.log('multiplyValues: newObj', newObj)
  return newObj
}

export interface MergeObjectsOptions {
  exception?: string
}

export const mergeObjects = (
  obj1: any,
  obj2: any,
  options?: MergeObjectsOptions,
): any => {
  const mergedObj = { ...obj1 }
  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      if (key === options?.exception) {
        mergedObj[key] = options.exception
      } else {
        mergedObj[key] += obj2[key]
      }
    } else {
      mergedObj[key] = obj2[key]
    }
  }
  return mergedObj
}
